<template>
  <div class="tabpage-content as-flex main-start cross-center">
    <el-tabs
      class="tab-row"
      type="card"
      :value="currentTab?currentTab.statusCode:undefined"
      closable
      @tab-remove="removeTab"
      @tab-click="handleClick"
    >
      <!-- <template v-for="(item,index) in tabs"> -->
      <el-tab-pane
        v-for="(item,index) in tabs"
        :key="item.statusCode + index"
        :label="item.title"
        :name="item.statusCode"
      ></el-tab-pane>
      <!-- </template> -->
    </el-tabs>
  </div>
</template>

<script>
import { findIndex, clone } from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "tabpage",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      tabs: "tabpage/getTabPages",
      currentTab: "tabpage/getCurrentTab"
    })
  },
  methods: {
    handleClick(tab, event) {
      let next_tab = clone(this.tabs[tab.index]);
      this.$router.push({
        name: next_tab.pathname,
        query: Object.assign(clone(next_tab.pathquery), {
          statusCode: next_tab.statusCode
        })
        // params: clone({ statusCode: next_tab.statusCode })
        // statusInfo: { ...next_tab.statusInfo } || {},
        // type: next_tab.type //index | movieLib | movies
      });
    },
    removeTab(targetName) {
      //只剩一个页签，不可删除
      if (this.tabs.length === 1) {
        return;
      }
      //如果删除当前页签，后移一位（没有后一位则选中前一位）
      if (targetName === this.currentTab.statusCode) {
        let delTabIndex = findIndex(this.tabs, function(o) {
          return o.statusCode === targetName;
        });
        let next_tab = this.tabs[delTabIndex + 1]
          ? this.tabs[delTabIndex + 1]
          : this.tabs[delTabIndex - 1];
        this.$router.push({
          name: next_tab.pathname,
          query: Object.assign(clone(next_tab.pathquery), {
            statusCode: next_tab.statusCode
          })
          // params: { statusCode: next_tab.statusCode }
          // type: next_tab.type, //index | movieLib | movies
          // movieIds: next_tab.movieIds
        });
      }
      this.$store.commit("tabpage/closeTab", { statusCode: targetName });
    }
  },
  watch: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.tabpage-content {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.tab-row {
  width: 100%;
  height: 100%;
}

/deep/ .el-tabs__header {
  margin: 0;
}
/deep/ .el-tabs__item {
  color: #666666;
}
/deep/ .el-tabs__item.is-active {
  color: #61b6e6;
}
/deep/ .el-tabs__item:hover {
  color: #61b6e6;
}
/deep/ .el-tabs__nav-prev {
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
/deep/ .el-tabs__nav-next {
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
